import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import GuestLayout from '../components/core/guest-layout';
import LoginComponent from '../screens/login';

const LoginCallback: React.FC = () => {
  return <div>Processing authentication...</div>;
};

const GuestRouter: React.FC = () => {
  const location = useLocation();

  return (
    <Routes>
      <Route path="/" element={<GuestLayout />}>
        <Route path="" element={<Navigate to="/login" state={{ from: location }} replace />} />
        <Route path="login" element={<LoginComponent />} />
        <Route path="login/callback" element={<LoginCallback />} />
        <Route path="logout/callback" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" state={{ from: location }} replace />} />
      </Route>
    </Routes>
  );
};

export default GuestRouter;
